var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useGoogleMaps } from '../../hooks';
var MapRelative = function (_a) {
    var _b = _a.isMobile, isMobile = _b === void 0 ? false : _b, isMapOpen = _a.isMapOpen, className = _a.className, style = _a.style, rest = __rest(_a, ["isMobile", "isMapOpen", "className", "style"]);
    var isLoading = useGoogleMaps();
    if (isLoading)
        return null;
    return (_jsx("div", __assign({ className: clsx('map-relative', className), style: __assign(__assign({}, style), { height: isMobile ? (isMapOpen ? '25rem' : '6rem') : undefined }) }, rest), void 0));
};
export default MapRelative;
//# sourceMappingURL=MapRelative.js.map